module.exports = __webpack_public_path__ + "static/media/IMG_3534.2960288f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/IMG_3534.jpg
// module id = 462
// module chunks = 0